import React, { useEffect, useState } from 'react';

// Bootstrap Imports
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// Styled Components
import styled from 'styled-components';

// Animation on Scroll
import Zoom from 'react-reveal/Zoom';

// Firebase Imports
import { storage } from '../../../config/fbConfig';

// Local Imports
import ParallaxSection from '../../layout/ParallaxSection';

const OurVoiceToneBackground = styled.div`
	width: 100%;
	background: url('/img/majo-fondo-valores.jpg') 0% 0% / cover no-repeat;
	background-size: auto;
	background-position: top center;

	@media (max-width: 768px) {
		background: url('/img/majo-fondo-valores-mobile.jpg') 0% 0% / cover
			no-repeat;
		background-size: auto;
		background-position: top center;
	}
`;

const OurVoiceTone = () => {
	// Component State
	const [parallaxImage, setParallaxImage] = useState('');

	// Component Hooks
	useEffect(() => {
		storage
			.ref('static-web-imgs')
			.child('voice-parallax-background_1440x810.jpg')
			.getDownloadURL()
			.then((res) => {
				setParallaxImage(res);
			});
	}, []);

	return (
		<div>
			<ParallaxSection
				background='rgba(30, 3, 67, 0.3)'
				height='55vh'
				image={parallaxImage}
				sectionTitleLine1='El tono de voz'
				sectionTitleLine2='que nos caracteriza'
				titleFontConfig={{
					color: '#fff',
					fontFamily: 'Syncopate',
					fontWeight: 600,
					textTransform: 'uppercase',
				}}
			/>
			<OurVoiceToneBackground>
				<Row
					className='mx-0'
					style={{
						minHeight: '115vh',
					}}>
					<Col
						className='d-flex flex-column align-items-center justify-content-around'
						md={6}>
						<Zoom>
							<div>
								<div className='ideas-circle voice-circle-one'>
									<p className='ideas-text'>Mantente Positivo</p>
									<div className='ideas-divider' />
									<p className='ideas-title'>Entusiasmo</p>
								</div>
							</div>
						</Zoom>
						<Zoom>
							<div>
								<div className='ideas-circle voice-circle-two'>
									<p className='ideas-text'>Usa el humor</p>
									<div className='ideas-divider' />
									<p className='ideas-title'>Ingenio descarado</p>
								</div>
							</div>
						</Zoom>
					</Col>
					<Col className='d-flex flex-column justify-content-around' md={6}>
						<Zoom>
							<div>
								<div className='ideas-circle voice-circle-three'>
									<p className='ideas-text'>Mantenlo Simple</p>
									<div className='ideas-divider' />
									<p className='ideas-title'>
										Dilo tal
										<br />
										como es
									</p>
								</div>
							</div>
						</Zoom>
						<Zoom>
							<div>
								<div className='ideas-circle voice-circle-four'>
									<p className='ideas-text'>Se Humano</p>
									<div className='ideas-divider' />
									<p className='ideas-title'>Amistoso y natural</p>
								</div>
							</div>
						</Zoom>
						<Zoom>
							<div>
								<div className='ideas-circle voice-circle-five'>
									<p className='ideas-text'>Hazlo fresco</p>
									<div className='ideas-divider' />
									<p className='ideas-title'>Hablabilidad</p>
								</div>
							</div>
						</Zoom>
					</Col>
				</Row>
			</OurVoiceToneBackground>
		</div>
	);
};

export default OurVoiceTone;
